import { Card, CardContent } from '@/components/ui/Card.tsx';
import { SubsectionTitle } from '@/components/ui/Title.tsx';
import { TaggableType } from '@/features/dashboard/tags/types/TaggableType.ts';
import TagPicker from '@/features/dashboard/tags/components/TagPicker.tsx';

/**
 * Detail-page / modal section for assigning tags to a single object.
 */
const TagPickerSection = ({
  targetType,
  targetId,
}: {
  targetType: TaggableType;
  targetId: string;
}) => {
  return (
    <Card>
      <CardContent className="space-y-3">
        <SubsectionTitle>Tagi</SubsectionTitle>
        <TagPicker targetType={targetType} targetId={targetId} />
      </CardContent>
    </Card>
  );
};

export default TagPickerSection;
